var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpaceTemplateBlank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 49,
    viewBox: "0 0 57 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.4304,
    height: 34.5,
    transform: "matrix(1 0 -5.44074e-05 1 18.5723 14.5004)",
    fill: "#594BFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38.4304,
    height: 34.5,
    transform: "matrix(1 0 -5.44074e-05 1 1.00293 1)",
    stroke: "#9FEEC9",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceTemplateBlank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-template-blank.0ab8367fc31ac208c32eb1cbd4c99199.svg";